import React, { useRef, useMemo } from 'react';
import useDuperbrowseScrollRestoration from '../../Duperbrowse/hooks/useDuperbrowseScrollRestoration';
import gridStyle from './GridRow.scss';
const HiddenGridRow = ({ start , end , getDuperbrowseItemId , marginTop , height  })=>{
    const itemIds = useMemo(()=>{
        return getDuperbrowseItemId ? Array(end - start).fill(0).map((_, i)=>getDuperbrowseItemId(i + start)) : [];
    }, [
        start,
        end,
        getDuperbrowseItemId
    ]);
    const rowRef = useRef(null);
    useDuperbrowseScrollRestoration(itemIds, rowRef);
    return /*#__PURE__*/ React.createElement("div", {
        className: gridStyle['row'],
        style: {
            marginTop,
            height
        },
        ref: rowRef
    });
};
HiddenGridRow.displayName = 'HiddenGridRow';
export default HiddenGridRow;
